module.exports = __webpack_public_path__ + "static/img/static-zoom-in.46e3e15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-zoom-in.png
// module id = 18
// module chunks = 0